import script from "./ServiceInstanceModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ServiceInstanceModal.vue?vue&type=script&setup=true&lang=ts"

import "./ServiceInstanceModal.vue?vue&type=style&index=0&id=1172c732&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1172c732"]])

export default __exports__